import axios from 'axios';
import Cookies from 'js-cookie';

export const getDashboardData = (path, params = {}, signal) => axios.get(
    `${import.meta.env.VITE_BASEURL}/get/dashboard${path}`,
    { params, signal, timeout: 30000, headers: { Authorization: `Bearer ${Cookies.get('auth_token')}` } }
).then(response => response.data);
